import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/orderlist/warning.png';
const _withScopeId = n => (_pushScopeId("data-v-46f4b45d"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "logo"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-transporttruck"
})], -1));
const _hoisted_2 = {
  class: "cont"
};
const _hoisted_3 = ["copyData"];
const _hoisted_4 = {
  key: 0,
  class: "info"
};
const _hoisted_5 = {
  key: 0,
  class: "line"
};
const _hoisted_6 = {
  key: 1,
  class: "none"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "暂无物流信息")], -1));
const _hoisted_8 = [_hoisted_7];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['logistics-box', 'render-hide-scroll', {
      'app': $options.isShow
    }])
  }, [_createElementVNode("header", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, "快递公司：" + _toDisplayString($setup.expressName), 1), _createElementVNode("p", null, "快递单号：" + _toDisplayString($setup.expressNo), 1)]), _withDirectives(_createElementVNode("input", {
    type: "hidden",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.expressNo = $event)
  }, null, 512), [[_vModelText, $setup.expressNo]]), _createElementVNode("span", {
    class: "copy",
    ref: "copyboard",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.copy && $options.copy(...args)),
    copyData: $setup.expressNo
  }, "复制单号", 8, _hoisted_3)]), $setup.logisticsList && $setup.logisticsList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.logisticsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "progress",
      key: index
    }, [index != $setup.logisticsList.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("span", {
      class: _normalizeClass(['flag', {
        ago: index != 0
      }])
    }, null, 2), _createElementVNode("p", {
      class: _normalizeClass(index != 0 ? 'ago' : '')
    }, _toDisplayString(item.status), 3), _createElementVNode("p", null, _toDisplayString(item.time), 1)]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))], 2);
}